module.exports = __webpack_public_path__ + "assets/img/font4.35673764.png";